// src/components/CartButton.js

import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../context/CartContext';

function CartButton() {
  const navigate = useNavigate();
  const cartContext = useContext(CartContext);

  // ✅ تأكد أن الـ Context محمّل بشكل صحيح
  if (!cartContext || !Array.isArray(cartContext.cart)) return null;

  const { cart } = cartContext;
  const totalItems = cart.length;

  return (
    <button
      onClick={() => navigate('/cart')}
      style={styles.cartButton}
    >
      🛒
      <span style={styles.badge}>{totalItems}</span>
    </button>
  );
}

const styles = {
  cartButton: {
    position: 'relative',
    backgroundColor: '#FF9659',
    border: 'none',
    borderRadius: '50%',
    width: '45px',
    height: '45px',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#fff',
    boxShadow: '0px 3px 8px rgba(0,0,0,0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  badge: {
    position: 'absolute',
    bottom: '-4px',
    right: '-4px',
    backgroundColor: '#A63A24',
    color: '#fff',
    fontSize: '12px',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '700',
    border: '2px solid #fff',
  }
};

export default CartButton;
